import CheckIcon from '@mui/icons-material/Check';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { Button } from '@verantos-dev/shared-components';

import { AttributeSelection } from './AttributeSelection';
import { ConceptAutocomplete } from './ConceptAutoComplete';
import { useEditConceptGroupAndAttrCard } from './useEditConceptGroupAndAttrCard';
import { AddedConcept } from '../../state/createProjectSlice';

interface EditConceptGroupAndAttrCardProps {
  concept: AddedConcept;
}

export const EditConceptGroupAndAttrCard = ({ concept }: EditConceptGroupAndAttrCardProps) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();

  const { removeAddedConcept, closeEditMode, doneButtonDisabled } = useEditConceptGroupAndAttrCard({
    concept,
  });

  return (
    <Box
      key={concept.conceptCardId}
      sx={{
        border: `1px solid ${theme.palette.divider}`,
        p: theme.spacing(4),
        borderRadius: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4),
      }}
    >
      <Box id="select-concept-group">
        <ConceptAutocomplete concept={concept} />
      </Box>
      <Box id="select-required-attributes">
        <AttributeSelection concept={concept} />
      </Box>
      <Box sx={{ display: 'flex', gap: theme.spacing(2), justifyContent: 'flex-end' }}>
        <Button
          startIcon={<DeleteOutlineIcon />}
          variant="outlined"
          onClickHandler={() => removeAddedConcept()}
          sx={{
            textTransform: 'none',
            fontSize: '14px',
            color: theme.palette.error.main,
            borderColor: theme.palette.error.main,
          }}
          id="remove-attributes-button"
          displayLabel={formatMessage({
            id: 'createProjectWizard.step.conceptGroupsAndAttributes.editcard.removeButton',
          })}
        />
        <Button
          startIcon={<CheckIcon />}
          variant="contained"
          onClickHandler={() => closeEditMode()}
          disabled={doneButtonDisabled}
          sx={{
            textTransform: 'none',
            fontSize: '14px',
            backgroundColor: theme.palette.primary.main,
          }}
          id="done-attributes-button"
          displayLabel={formatMessage({
            id: 'createProjectWizard.step.conceptGroupsAndAttributes.editcard.doneButton',
          })}
        />
      </Box>
    </Box>
  );
};
